// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import {
  Input,
  Link,
  Button,
  ButtonComposed,
  modal,
  Select,
} from "@lifepay/rc-ui-toolkit";
import { Lock } from "@lifepay/redux-subsystem-access";

// ABSOLUTE PATH IMPORTS
import { LOCK_KEYS } from "accessConfig";
import CardStatusSwitch from "data-containers/CardStatusSwitch";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./CardStatusControl.m.scss";

@themr("@lifepay/CardStatusControl", styles)
export default class CardStatusControl extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object,
    isValid: PropTypes.bool,
    cardId: PropTypes.string,
    onSuccess: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      blockReasonId: "3",
      blockComment: "",
      loading: false,
      error: null,
      submitButtonState: "normal",
    };
  }

  activateCard = ({ activateCard }) => {};

  blockCard = ({ activateCard }) => {};

  render() {
    const { theme, cardId, isValid, onSuccess } = this.props;
    const {
      blockComment,
      blockReasonId,
      loading,
      submitButtonState,
      error,
    } = this.state;
    return (
      <modal.ModalController>
        {({ isOpen, close, open }) => {
          return (
            <React.Fragment>
              <Lock
                lockId={isValid ? LOCK_KEYS.CARD_BLOCK : LOCK_KEYS.CARD_UNBLOCK}
                type={"lock"}
                theme={{
                  wrapper: theme.button,
                }}
              >
                <Button
                  type={isValid ? "negative" : "main"}
                  size={"small"}
                  onClick={open}
                >
                  {isValid ? "Заблокировать" : "Активировать"}
                </Button>
              </Lock>
              <modal.ModalBox
                isOpen={isOpen}
                close={() => {
                  if (!loading) {
                    close();
                  }
                }}
                theme={{
                  inner: theme.modal,
                }}
              >
                <CardStatusSwitch
                  cardId={cardId}
                  blockReasonId={blockReasonId}
                  blockComment={blockComment}
                >
                  {({ activateCard, blockCard }) => {
                    const submit = (
                      <div className={classnames(theme.submit)}>
                        <ButtonComposed
                          state={submitButtonState}
                          disabled={submitButtonState !== "normal"}
                          type={"main"}
                          size={"small"}
                          text={"Подтвердить"}
                          theme={{
                            wrapper: theme.button,
                          }}
                          onClick={() => {
                            this.setState({
                              loading: true,
                              submitButtonState: "loading",
                            });
                            const method = isValid ? blockCard : activateCard;
                            method({
                              update: (proxy, response) => {
                                this.setState({
                                  loading: false,
                                  submitButtonState: "normal",
                                });
                                onSuccess();
                                close();
                              },
                            }).catch((e) => {
                              this.setState({
                                loading: false,
                                error: e,
                                submitButtonState: "error",
                              });
                            });
                          }}
                        >
                          {"Подтвердить"}
                        </ButtonComposed>
                        <Button
                          type={loading ? "disabled" : "alt"}
                          size={"small"}
                          disabled={loading}
                          theme={{
                            wrapper: theme.button,
                          }}
                          onClick={() => {
                            close();
                          }}
                        >
                          {"Отмена"}
                        </Button>
                      </div>
                    );

                    return isValid ? (
                      <div className={classnames(theme["modal-content"])}>
                        <div>
                          <div
                            className={classnames(theme.summary)}
                          >{`Заблокировать карту`}</div>
                          <Select
                            id={"blockReasonId"}
                            value={blockReasonId}
                            hideChooseAll={true}
                            options={[
                              { value: "3", label: "Утрата/порча" },
                              { value: "4", label: "По инициативе банка" },
                              { value: "9", label: "Кража" },
                              {
                                value: "10",
                                label: "Обслуживание приостановлено",
                              },
                            ]}
                            onChange={({ value }) => {
                              this.setState({
                                blockReasonId: value,
                              });
                            }}
                          />
                          <Input
                            value={blockComment}
                            controlled
                            onChange={({ value }) => {
                              this.setState({ blockComment: value });
                            }}
                          >
                            {"Комментарий"}
                          </Input>
                        </div>
                        {submit}
                      </div>
                    ) : (
                      <div
                        className={classnames(
                          theme["modal-content"],
                          theme.activate
                        )}
                      >
                        <div
                          className={classnames(theme.summary)}
                        >{`Активировать карту`}</div>
                        {error ? (
                          <React.Fragment>
                            <div className={classnames(theme.summary)}>
                              {error.message}
                            </div>
                            <div className={classnames(theme.summary)}>
                              <Link
                                type={"negative"}
                                withRouter={false}
                                onClick={() => {
                                  this.setState({
                                    error: null,
                                    submitButtonState: "normal",
                                  });
                                }}
                              >
                                {"Очистить ошибку"}
                              </Link>
                            </div>
                          </React.Fragment>
                        ) : null}
                        {submit}
                      </div>
                    );
                  }}
                </CardStatusSwitch>
              </modal.ModalBox>
            </React.Fragment>
          );
        }}
      </modal.ModalController>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/emission/cards/controls/CardStatusControl/CardStatusControl.js